import React from 'react'
import IconPng from 'atoms/IconPng'
import { Label } from 'atoms/Texts'
import { FlexRow, FlexCol } from './styles'

const ic_err_502 = require('App/assets/images/ic_err_502.png')

const ErrorMaintenance = () => {
  return (
    <FlexRow>
      <FlexCol>
        <IconPng srcIcon={ic_err_502} size={'auto'} h={'220'} mb={'50px'} />
        <Label lineheight={'48px'} mb={'5px'} size={'36px'}>
          Maintenance
        </Label>
        <Label weight={'400'} lineheight={'36px'} mb={'35px'} size={'18px'}>
          Please comeback again later
        </Label>
      </FlexCol>
    </FlexRow>
  )
}

export default ErrorMaintenance
